import React from 'react';
import Config from '../utils/config';
import Label from '../utils/label';
import getMomentTimeZone from '../utils/getMomentTimeZone';
import getMoment from '../utils/getMoment';
import { applyCdnUrl } from '../utils/site-utils';

const PhaseOutPresentational = React.memo(props => {
    const lbl_phase_out_msg1 = Label.lbl_phase_out_msg1.replace('{{newVersionImgUrl}}', props.newVersionImgUrl);
    const lbl_phase_out_msg2 = Label.lbl_phase_out_msg2.replace('{{phaseOutShowTime}}', props.phaseOutShowTime);

    return (
        <div className="popupPanel popupPanelClose">
            <div className="panelImgBox" />
            <div className="panelInfo">
                <i className="icon-close" onClick={props.close} />
                <div className="col" dangerouslySetInnerHTML={{__html: lbl_phase_out_msg1}} />
                <div className="col" dangerouslySetInnerHTML={{__html: lbl_phase_out_msg2}} />
                <div className="btn" onClick={props.switchToNewAsia}>{Label.lbl_try_it_now}</div>
            </div>
        </div>
    );
});

export default class PhaseOut extends React.PureComponent {

    static displayName = 'PhaseOut';

    state = {
        open: false,
        phaseOutShowTime: ''
    }

    async init() {
        await getMoment();
        const moment = await getMomentTimeZone();
        const phaseOutShowTime = moment.tz(new Date(Config.appConfig.PhaseOutShowTime), 'Asia/Taipei');
        // Config.appConfig.phaseOutShowTime 存在，且該show的時間已到
        const open = Config.appConfig.PhaseOutShowTime && moment(phaseOutShowTime).subtract(1, 'months').isBefore(moment());
        if (open) {
            // 把台北時區轉成當地時區
            const phaseOutLocalTime = phaseOutShowTime.tz(moment.tz.guess());
            const phaseOutShowTimeStr = this.isChinese ? phaseOutLocalTime.format('gggg年MM月DD日') : phaseOutLocalTime.format('gggg/MM/DD');
            this.setState({
                open: true,
                phaseOutShowTime : phaseOutShowTimeStr
            });
        }
    }

    switchToNewAsia() {
        window.ReceiveCallback({ data: 'ToNewView' });
    }

    get isChinese() {
        const userLang = Config.appConfig.UserLang;
        return userLang === 'ch' || userLang === 'cs';
    }

    close = () => {
        this.setState({ open: false });
    }

    componentDidMount() {
        this.init();
    }

    render() {
        const userLang = Config.appConfig.UserLang;
        const templatePath = Config.appConfig.TemplatePath;
        const newVersionImgUrl = applyCdnUrl(`/${templatePath}${userLang}/images/NewVersion.png?newImg=2018121201`);

        return this.state.open && (
            <PhaseOutPresentational
                userLang={userLang}
                newVersionImgUrl={newVersionImgUrl}
                phaseOutShowTime={this.state.phaseOutShowTime}
                switchToNewAsia={this.switchToNewAsia}
                close={this.close}
            />
        );
    }
}